






































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import userService from '@/services/hub/user';
import { registerLog } from '@/services/hub/logsAction';
import jwtDecode from 'jwt-decode';

export default Vue.extend({
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: '', value: 'data-table-select', sortable: false },
        { text: this.$t('File'), value: 'icon', sortable: false },
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Duration'), value: 'duration' },
        { text: this.$t('Access'), value: 'access' },
        { text: this.$t('send_date'), value: 'send_date' },
        { text: this.$t('size'), value: 'size', sortable: true },
        { text: this.$t('Actions'), value: 'actions', sortable: false },
      ],
      selected: [] as any,
      createFolderDialog: false,
      renameFolderDialog: false,
      moveFolderDialog: false,
      newFolderName: '',
      renameFolderName: '',
      moveToFolderId: null as string | null,
      valid: false,
      folderId: 0,
      planOdId: 0,
      userToken: '' as any,
      customerPlansId: 0,
      folders: [] as any,
      breadcrumb: [] as any[],
      secretPlayer: '',
      searchUpload: '',
      showReplaceVideoDialog: false,
      selectedVideoToReplace: null as any,
      availableItems: [] as any[],
      showConfirmation: false,
      moveVideoDialog: false,
      id_customer: 0,
      username: '',
      preloadedThumbs: {} as Record<string, boolean>,
      lastAPICall: 0, // Timestamp da última chamada à API
      apiCallInterval: 1000, // Intervalo mínimo entre chamadas à API (em ms)
      pendingAPICall: false, // Flag para controlar chamadas simultâneas
      viewsCache: {} as Record<string, any>, // Cache para visualizações
      rules: {
        required: (v: string) => !!v || 'Este campo é obrigatório',
        maxLength: (v: string) => (v && v.length <= 50) || 'Máximo de 50 caracteres permitidos',
      },
      sortField: 'date',
      sortOrder: 'desc',
    };
  },
  watch: {
    'folder.items': {
      handler() {
        this.validateThumbnails();
      },
      deep: true,
    },
    sortField() {
      this.getAllVideos();
    },
    sortDescBoolean() {
      this.sortOrder = this.sortDescBoolean ? 'desc' : 'asc';
      this.getAllVideos();
    },
  },
  computed: {
    sortDescBoolean: {
      get(): boolean {
        return this.sortOrder === 'desc';
      },
      set(value: boolean) {
        this.sortOrder = value ? 'desc' : 'asc';
      },
    },
    sortedItems(): any[] {
      if (!this.folder || !this.folder.items || !Array.isArray(this.folder.items)) {
        return [];
      }

      const folders = this.folder.items.filter((item: any) => item.type === 'folder');
      const videos = this.folder.items.filter((item: any) => item.type === 'video');

      videos.sort((a: any, b: any) => {
        try {
          if (this.sortField === 'size') {
            if (a.original_size !== undefined && b.original_size !== undefined) {
              return this.sortDescBoolean
                ? b.original_size - a.original_size
                : a.original_size - b.original_size;
            }
            const getSizeValue = (sizeStr: string) => {
              const match = sizeStr.match(/^([\d.]+)/);
              return match ? parseFloat(match[1]) : 0;
            };
            const getSizeUnit = (sizeStr: string) => {
              const match = sizeStr.match(/([A-Za-z]+)$/);
              return match ? match[1].toUpperCase() : '';
            };
            const units = ['B', 'KB', 'MB', 'GB', 'TB'];
            const unitValueA = units.indexOf(getSizeUnit(a.size));
            const unitValueB = units.indexOf(getSizeUnit(b.size));
            if (unitValueA !== unitValueB) {
              return this.sortDescBoolean
                ? unitValueB - unitValueA
                : unitValueA - unitValueB;
            }
            const sizeValueA = getSizeValue(a.size);
            const sizeValueB = getSizeValue(b.size);
            return this.sortDescBoolean
              ? sizeValueB - sizeValueA
              : sizeValueA - sizeValueB;
          }
          if (this.sortField === 'date') {
            if (!a.send_date || !b.send_date) return 0;
            const datePartsA = a.send_date.split('/');
            const datePartsB = b.send_date.split('/');
            if (datePartsA.length !== 3 || datePartsB.length !== 3) return 0;
            const dateA = new Date(
              parseInt(datePartsA[2], 10),
              parseInt(datePartsA[1], 10) - 1,
              parseInt(datePartsA[0], 10),
            );
            const dateB = new Date(
              parseInt(datePartsB[2], 10),
              parseInt(datePartsB[1], 10) - 1,
              parseInt(datePartsB[0], 10),
            );
            if (Number.isNaN(dateA.getTime()) || Number.isNaN(dateB.getTime())) return 0;
            return this.sortDescBoolean
              ? dateB.getTime() - dateA.getTime()
              : dateA.getTime() - dateB.getTime();
          }

          // Default sort (date)
          if (!a.send_date || !b.send_date) return 0;
          const datePartsA = a.send_date.split('/');
          const datePartsB = b.send_date.split('/');
          if (datePartsA.length !== 3 || datePartsB.length !== 3) return 0;
          const dateA = new Date(
            parseInt(datePartsA[2], 10),
            parseInt(datePartsA[1], 10) - 1,
            parseInt(datePartsA[0], 10),
          );
          const dateB = new Date(
            parseInt(datePartsB[2], 10),
            parseInt(datePartsB[1], 10) - 1,
            parseInt(datePartsB[0], 10),
          );
          if (Number.isNaN(dateA.getTime()) || Number.isNaN(dateB.getTime())) return 0;
          return dateB.getTime() - dateA.getTime();
        } catch (e) {
          return 0;
        }
      });

      return [...folders, ...videos];
    },
  },
  async mounted() {
    await this.userInformation();
    await this.getBreadcrumb();
    this.validateThumbnails();

    // Verificar thumbnails a cada 3 segundos, caso alguma não tenha carregado
    const thumbCheckInterval = setInterval(() => {
      const pendingThumbs = this.folder.items.some(
        (item: any) => item.type === 'video' && item.thumb && item.thumbValid === null,
      );

      if (pendingThumbs) {
        this.validateThumbnails();
      } else {
        clearInterval(thumbCheckInterval);
      }
    }, 3000);

    // Limpar o intervalo quando o componente for destruído
    this.$once('hook:beforeDestroy', () => {
      clearInterval(thumbCheckInterval);
    });
  },
  methods: {
    async userInformation() {
      const userInfo = localStorage.getItem('user');
      if (userInfo) {
        const user = JSON.parse(userInfo);

        const { token } = user;
        const decodedToken = jwtDecode(token) as any;
        this.username = decodedToken.sub.nickname;
        this.id_customer = decodedToken.sub.id_customers;
        this.customerPlansId = user.user.plan_id;
        this.userToken = user.token;
        await this.getPlanOd(this.customerPlansId);
        await this.getBreadcrumb();
        await this.getCustomerPlan(this.planOdId);
      }
    },
    async logUserAction(action: string, status: string, description: string) {
      try {
        const logData = {
          id_customers: this.id_customer,
          username: this.username,
          action,
          status,
          description,
        };

        await registerLog(logData);
        console.log('Log registrado com sucesso!');
      } catch (error) {
        console.error('Erro ao registrar o log:', error);
      }
    },
    async getPlanOd(customerPlansId: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/event/getPlanOd/${customerPlansId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        this.planOdId = response.data.customerPlansOdId;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async openFolder(item: any) {
      if (item && item.type === 'folder') {
        await this.$router.push({ name: 'Gallery', params: { id: String(item.id) } });
        await this.getBreadcrumb();
      } else {
        await this.$router.push({ name: 'Video', params: { id: String(item.id) } });
      }
    },
    async validateThumbnails() {
      if (!this.folder || !this.folder.items || !Array.isArray(this.folder.items)) {
        return;
      }

      // Primeiro, definir thumbValid como null para vídeos sem status definido
      this.folder.items.forEach((item: any) => {
        if (item.type === 'video' && item.thumb && item.thumbValid === undefined) {
          Vue.set(item, 'thumbValid', null);
        }
      });

      // Identificar apenas thumbnails que precisam de validação
      const needValidation = this.folder.items.filter(
        (item: any) => item.type === 'video' && item.thumb && item.thumbValid === null,
      );

      if (needValidation.length === 0) return;

      // Usando Promise.all para carregar todas as thumbnails pendentes em paralelo
      const loadingPromises = needValidation.map((item: any) => new Promise<void>((resolve) => {
        // Verificar se já pré-carregamos esta imagem
        if (this.preloadedThumbs[item.thumb]) {
          Vue.set(item, 'thumbValid', true);
          resolve();
          return;
        }

        const img = new Image();
        const timeoutId = setTimeout(() => {
          Vue.set(item, 'thumbValid', false);
          resolve();
        }, 5000); // 5 segundos de timeout

        img.onload = () => {
          clearTimeout(timeoutId);
          Vue.set(item, 'thumbValid', true);
          this.preloadedThumbs[item.thumb] = true;
          resolve();
        };

        img.onerror = () => {
          clearTimeout(timeoutId);
          Vue.set(item, 'thumbValid', false);
          resolve();
        };

        img.src = item.thumb;
      }));

      await Promise.all(loadingPromises);
    },
    showCreateFolderDialog() {
      this.createFolderDialog = true;
    },
    closeCreateFolderDialog() {
      this.createFolderDialog = false;
      this.newFolderName = '';
    },
    showRenameFolderDialog() {
      this.renameFolderDialog = true;
      this.renameFolderName = this.selected[0].name;
    },
    closeRenameFolderDialog() {
      this.renameFolderDialog = false;
      this.renameFolderName = '';
      this.selected = [];
    },
    async showMoveFolderDialog() {
      this.moveFolderDialog = true;
      await this.getGallerySelect(this.planOdId);
    },
    closeMoveFolderDialog() {
      this.moveFolderDialog = false;
      this.moveToFolderId = null;
      this.selected = [];
    },
    async showMoveVideoDialog() {
      this.moveVideoDialog = true;
      await this.getGallerySelect(this.planOdId);
    },
    closeMoveVideoDialog() {
      this.moveVideoDialog = false;
      this.moveToFolderId = null;
      this.selected = [];
    },
    showToast(key: string, type: string) {
      const text = this.$t(key);
      this.$store.dispatch('notification/create', {
        text,
        type,
      });
    },
    async getGallery(planId: number, name: string, folderId: any) {
      // Evitar múltiplas chamadas simultâneas
      // if (this.pendingAPICall) {
      //   return;
      // }
      // eslint-disable-next-line eqeqeq
      if (folderId == null || folderId == undefined) {
        // eslint-disable-next-line no-param-reassign
        folderId = null;
      }

      // Throttling da API - verificar se passou tempo suficiente desde a última chamada
      const now = Date.now();
      if (now - this.lastAPICall < this.apiCallInterval) {
        // Se não passou tempo suficiente, reagendar a chamada
        setTimeout(() => {
          this.getGallery(planId, name, folderId);
        }, this.apiCallInterval);
        return;
      }

      this.pendingAPICall = true;
      this.lastAPICall = now;

      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/galleries/${planId}?`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        let folderName: any[] = [];
        // eslint-disable-next-line max-len, eqeqeq
        if (folderId == null || folderId == undefined) {
          // eslint-disable-next-line max-len
          folderName = response.data.galleries.filter((gallery: any) => gallery.parentId === 0 || gallery.parentId === null);
        } else {
          folderName = response.data.galleries.filter(
            (item: any) => Number(item.parentId) === Number(folderId),
          );
        }

        if (folderName.length > 0) {
          const videosArray = [] as any;
          // eslint-disable-next-line array-callback-return
          this.folder.items.map((video: any) => {
            if (video.type === 'video') {
              videosArray.push(video);
            }
          });

          // Manter os vídeos na lista e adicionar pastas
          this.folder.items = [
            ...folderName.map((gallery: any) => ({
              id: gallery.id,
              name: gallery.name,
              type: 'folder' as const,
            })),
            ...videosArray,
          ];
        }
        this.pendingAPICall = false;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.pendingAPICall = false;
      }
    },
    async getGalleryVideos(planId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/galleries/videos/${planId}?search=${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        // Ordenando os vídeos por data de criação - mais recentes primeiro
        response.data.sort((a: any, b: any) => {
          const dateA = new Date(a.created_date).getTime();
          const dateB = new Date(b.created_date).getTime();
          return dateB - dateA;
        });

        const items = await Promise.all(
          response.data.map(async (video: any) => {
            const access = await this.fetchDailyViews(video);
            return {
              id: video.id,
              name: video.name,
              access,
              duration: video.time,
              send_date: video.created_date,
              size: video.size,
              original_size: video.size, // Armazenar tamanho original para ordenação
              hash: video.hash,
              storageHash: video.storage_hash,
              type: 'video',
            };
          }),
        );

        this.folder.items = items;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async getGalleryVideosSearch(planId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/galleries/videos/${planId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        const searchTerm = this.searchUpload
          .toLowerCase()
          .trim()
          .split('/');
        const lastTerm = searchTerm[searchTerm.length - 1];

        // Filtrar e depois ordenar os vídeos por data de criação - mais recentes primeiro
        const filteredData = response.data
          .filter((video: any) => video.name.toLowerCase().includes(searchTerm))
          .sort((a: any, b: any) => {
            const dateA = new Date(a.created_date).getTime();
            const dateB = new Date(b.created_date).getTime();
            return dateB - dateA;
          });

        const items = await Promise.all(
          response.data
            // eslint-disable-next-line max-len
            .filter(
              (video: any) => video.name.toLowerCase().includes(lastTerm)
                || video.hash.toLowerCase().includes(lastTerm),
            )
            .map(async (video: any) => {
              const access = await this.fetchDailyViews(video);
              return {
                id: video.id,
                name: video.name,
                access,
                duration: video.time,
                send_date: video.created_date,
                size: video.size,
                original_size: video.size, // Armazenar tamanho original para ordenação
                hash: video.hash,
                storageHash: video.storage_hash,
                parentId: video.parentId,
                type: 'video',
              };
            }),
        );

        // Atualiza os itens da pasta
        this.folder.items = items;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    // eslint-disable-next-line consistent-return, @typescript-eslint/camelcase
    async getViews(video_hash: any) {
      // Verificar o cache em memória
      if (this.viewsCache[video_hash]) {
        return this.viewsCache[video_hash];
      }

      const apiUrl = process.env.VUE_APP_API_URL;
      try {
        // eslint-disable-next-line @typescript-eslint/camelcase
        const response = await axios.get(`${apiUrl}/views/${video_hash}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
          },
        });

        if (response.status !== 200) {
          throw new Error('Erro ao chamar a API');
        }

        const { data } = response;

        // Armazenar no cache em memória
        this.viewsCache[video_hash] = data;

        return data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    // eslint-disable-next-line consistent-return
    async fetchDailyViews(video: any) {
      if (!video || !video.hash) {
        return 0; // Retornar 0 se o vídeo ou hash não estiver disponível
      }

      const today = new Date().toISOString().split('T')[0];
      const storageKey = `views_${video.hash}`;

      // Verificar cache primeiro
      const storedItem = localStorage.getItem(storageKey);
      if (storedItem) {
        try {
          const storedData = JSON.parse(storedItem);
          // Usar cache se for do mesmo dia
          if (storedData.date === today) {
            if (
              storedData.access
              && storedData.access.views
              && typeof storedData.access.views.count !== 'undefined'
            ) {
              return storedData.access.views.count;
            }
            // Cache está corrompido mas do mesmo dia, retornar 0 para evitar nova chamada
            return 0;
          }
        } catch (e) {
          // Se houver erro ao parsear JSON, ignorar o cache
          localStorage.removeItem(storageKey);
        }
      }

      // Se chegou aqui, precisamos buscar os dados do servidor
      try {
        const access = await this.getViews(video.hash);

        if (access && access.views && typeof access.views.count !== 'undefined') {
          // Salvar no cache
          localStorage.setItem(
            storageKey,
            JSON.stringify({
              date: today,
              access,
            }),
          );

          // Atualizar detalhes do vídeo em segundo plano
          this.saveVideoDetails(video, access.views.count).catch(() => {
            // Ignora erro para não bloquear a UI
          });

          return access.views.count;
        }

        return 0; // Valor padrão se não conseguir recuperar
      } catch (error) {
        // Em caso de erro, retornar 0 e não bloquear o fluxo
        return 0;
      }
    },

    async saveVideoDetails(video: any, access: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        await axios.put(
          `${apiUrl}/updateVideoAccess/${this.planOdId}/${video.id}`,
          {
            access,
            parentId: video.parentId,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
      } catch (error) {
        console.error('Error saving video details:', error);
      }
    },
    async getGallerySelect(planId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/galleries/${planId}?`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        // eslint-disable-next-line max-len
        const folderId = response.data.galleries.filter(
          (item: any) => Number(item.id) !== Number(this.selected[0].id),
        );

        if (folderId.length > 0) {
          this.folders = [
            ...folderId.map((gallery: any) => ({
              id: gallery.id,
              name: gallery.name,
              type: 'folder' as const,
            })),
          ];
        }
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    removeSelectedItems() {
      this.selected.forEach((item: any) => {
        if (item.type === 'folder') {
          this.removeFolder(item.id);
        } else {
          this.removeVideo(item);
        }
      });
      this.selected = [];
    },
    async removeFolder(folderId: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.delete(`${apiUrl}/galleries/${this.planOdId}/${folderId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        if (response.status === 200) {
          // eslint-disable-next-line max-len
          const index = this.folder.items.findIndex(
            (folderItem: any) => folderItem.id === folderId,
          );
          const folderName = this.folder.items[index].name;
          if (index !== -1) {
            this.folder.items.splice(index, 1);
          }
          this.showToast('folder_deleted_successfully', 'success');
          const description = `Pasta ${folderName} deletada com sucesso.`;
          await this.logUserAction('Deletion', 'Success', description);
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.error) {
          // eslint-disable-next-line max-len
          const index = this.folder.items.findIndex(
            (folderItem: any) => folderItem.id === folderId,
          );
          const folderName = this.folder.items[index].name;
          const description = `Erro ao deletar pasta ${folderName}.`;
          await this.logUserAction('Deletion', 'Error', description);
          this.showToast(error.response.data.error, 'error');
        } else {
          // eslint-disable-next-line max-len
          const index = this.folder.items.findIndex(
            (folderItem: any) => folderItem.id === folderId,
          );
          const folderName = this.folder.items[index].name;
          this.showToast('folder_deletion_failed', 'error');
          const description = `Erro ao deletar pasta ${folderName}.`;
          await this.logUserAction('Deletion', 'Error', description);
          console.error('Erro ao chamar a API:', error);
        }
      }
    },
    async removeVideo(video: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL as string;
        const response = await axios.put(
          `${apiUrl}/removeFileOd/${this.planOdId}/${video.hash}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
        if (response.status === 200) {
          // eslint-disable-next-line max-len
          const index = this.folder.items.findIndex((videoItem: any) => videoItem.id === video.id);
          if (index !== -1) {
            this.folder.items.splice(index, 1);
          }
          const description = `Vídeo ${video.name}, com hash ${video.hash} foi deletado com sucesso.`;
          await this.logUserAction('Deletion', 'Success', description);
          this.showToast('Video successfully deleted', 'success');
        }
      } catch (error) {
        try {
          const apiUrl = process.env.VUE_APP_API_URL as string;
          const response = await axios.put(
            `${apiUrl}/removeFileOd/${this.planOdId}/${video.hash}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${this.userToken}`,
              },
            },
          );
          if (response.status === 200) {
            // eslint-disable-next-line max-len
            const index = this.folder.items.findIndex(
              (videoItem: any) => videoItem.id === video.id,
            );
            if (index !== -1) {
              this.folder.items.splice(index, 1);
            }
            const description = `Vídeo ${video.name}, com hash ${video.hash} foi deletado com sucesso.`;
            await this.logUserAction('Deletion', 'Success', description);
            this.showToast('Video successfully deleted on retry', 'success');
          }
        } catch (retryError) {
          const description = `Erro ao deletar vídeo ${video.name}, com hash ${video.hash}.`;
          await this.logUserAction('Deletion', 'Error', description);
          this.showToast('Unable to perform this action, please try again later.', 'error');
        }
      }
    },
    async createFolder() {
      if (this.$refs.form && (this.$refs.form as any).validate) {
        try {
          const folderId = this.$route.params.id;
          const apiUrl = process.env.VUE_APP_API_URL;

          const response = await axios.post(
            `${apiUrl}/galleries/${this.planOdId}`,
            {
              parentId: folderId,
              name: this.newFolderName,
            },
            {
              headers: {
                Authorization: `Bearer ${this.userToken}`,
              },
            },
          );

          await this.getGallery(this.planOdId, this.newFolderName, Number(folderId));
          this.showToast('folder_created_successfully', 'success');
          const description = `Pasta ${this.newFolderName} criada com sucesso.`;
          await this.logUserAction('Creation', 'Success', description);
          this.closeCreateFolderDialog();
        } catch (error) {
          console.error('Erro ao criar pasta:', error);
          const description = `Erro ao criar pasta ${this.newFolderName}`;
          await this.logUserAction('Creation', 'Error', description);
          this.showToast('folder_creation_failed', 'error');
        }
      }
    },
    async renameFolder() {
      if (this.$refs.renameForm && (this.$refs.renameForm as any).validate) {
        try {
          const folderId = this.selected[0].id;
          const apiUrl = process.env.VUE_APP_API_URL;

          const response = await axios.put(
            `${apiUrl}/galleries/${this.planOdId}/${folderId}`,
            {
              parentId: this.$route.params.id,
              name: this.renameFolderName,
            },
            {
              headers: {
                Authorization: `Bearer ${this.userToken}`,
              },
            },
          );

          if (response.status === 200) {
            // eslint-disable-next-line max-len
            const index = this.folder.items.findIndex(
              (folderItem: any) => folderItem.id === folderId,
            );
            if (index !== -1) {
              this.folder.items[index].name = this.renameFolderName;
            }
            const description = `Sucesso ao renomear pasta ${this.selected[0].name} para ${this.renameFolderName}.`;
            await this.logUserAction('Modification', 'Success', description);
            this.showToast('folder_renamed_successfully', 'success');
            this.closeRenameFolderDialog();
          }
        } catch (error) {
          console.error('Erro ao renomear pasta:', error);
          const description = `Erro renomear pasta ${this.selected[0].name} para ${this.renameFolderName}.`;
          await this.logUserAction('Modification', 'Error', description);
          this.showToast('folder_rename_failed', 'error');
        }
      }
    },
    async moveFolder() {
      const destinationFolder = this.folder.items.find(
        (folderItem: any) => folderItem.id === this.moveToFolderId,
      );
      const destinationFolderName = destinationFolder ? destinationFolder.name : 'Desconhecida';
      if (this.$refs.moveForm && (this.$refs.moveForm as any).validate) {
        try {
          const folderId = this.selected[0].id;
          const apiUrl = process.env.VUE_APP_API_URL;

          const response = await axios.put(
            `${apiUrl}/galleries/${this.planOdId}/${folderId}`,
            {
              parentId: this.moveToFolderId,
            },
            {
              headers: {
                Authorization: `Bearer ${this.userToken}`,
              },
            },
          );

          if (response.status === 200) {
            // eslint-disable-next-line max-len
            const index = this.folder.items.findIndex(
              (folderItem: any) => folderItem.id === folderId,
            );
            if (index !== -1) {
              this.folder.items.splice(index, 1);
            }
            const description = `Sucesso ao mover pasta ${this.selected[0].name} para ${destinationFolderName}`;
            await this.logUserAction('Modification', 'Success', description);
            this.showToast('folder_moved_successfully', 'success');
            this.closeMoveFolderDialog();
          }
        } catch (error) {
          const description = `Erro ao mover pasta ${this.selected[0].name} para ${destinationFolderName}`;
          await this.logUserAction('Modification', 'Error', description);
          console.error('Erro ao mover pasta:', error);
          this.showToast('folder_move_failed', 'error');
        }
      }
    },
    async navigateToFolder(folderId: any) {
      await this.$router.push({ name: 'Gallery', params: { id: String(folderId) } });
      await this.getBreadcrumb();
    },
    async navigateToVideo(videoId: any) {
      await this.$router.push({ name: 'Video', params: { id: String(videoId) } });
      await this.getBreadcrumb();
    },
    async getCustomerPlan(id: string | number) {
      const response = await userService.getCustomerPlan(id);
      this.secretPlayer = response.data.data.secret;
    },
    onClickVisualize(video: any) {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      const videoUrl = `${baseUrl}${this.secretPlayer}/${video.hash}`;
      window.open(videoUrl, '_blank');
    },
    async onClickCopyIframe(video: any) {
      const env = process.env.VUE_APP_ENV || 'production';

      let baseUrl;
      if (env === 'sandbox') {
        baseUrl = 'https://player-sandbox.jmvstream.com/';
      } else if (env === 'staging') {
        baseUrl = 'https://player-staging.jmvstream.com/';
      } else {
        baseUrl = 'https://player.jmvstream.com/';
      }

      const videoUrl = `${baseUrl}${this.secretPlayer}/${video.hash}`;
      const iframeCode = `<iframe allow="0" allowfullscreen class="jmvplayer" frameborder="0" src="${videoUrl}" width="640" height="360"></iframe>`;

      try {
        await navigator.clipboard.writeText(iframeCode);
        this.showToast('iframe_copied_successfully', 'success');
      } catch (error) {
        console.error('Erro ao copiar iframe:', error);
        this.showToast('iframe_copy_failed', 'error');
      }
    },

    async getAllVideos() {
      // Evitar múltiplas chamadas simultâneas
      if (this.pendingAPICall) {
        return;
      }

      // Throttling da API - verificar se passou tempo suficiente desde a última chamada
      const now = Date.now();
      if (now - this.lastAPICall < this.apiCallInterval) {
        // Se não passou tempo suficiente, reagendar a chamada
        setTimeout(() => {
          this.getAllVideos();
        }, this.apiCallInterval);
        return;
      }

      this.pendingAPICall = true;
      this.lastAPICall = now;

      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        if (this.searchUpload === '') {
          // Quando o campo de pesquisa estiver vazio, voltamos para a pasta atual
          // Em caso de pasta root, currentFolderId pode ser null/undefined
          const currentFolderId = this.$route.params.id || null;
          await this.getGalleryVideos(this.planOdId);
          await this.getGallery(this.planOdId, '', currentFolderId);
          await this.getBreadcrumb();
          this.pendingAPICall = false;
          this.$emit('get-breadcrumb', this.breadcrumb);
        } else {
          await this.getGalleryVideosSearch(this.planOdId);
          this.pendingAPICall = false;
        }

        // Aplicar ordenação por data de upload (mais recentes primeiro)
        // para todos os vídeos independente do método de carregamento
      } catch (error) {
        console.error('Erro ao buscar vídeos:', error);
      } finally {
        this.pendingAPICall = false;
      }
    },
    formatVideoDuration(time: string) {
      const [hours, minutes, seconds] = time.split(':');
      return `${hours}:${minutes}:${seconds.split('.')[0]}`;
    },
    formatFileSize(size: any) {
      if (size === 0) return '0 B';

      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(size) / Math.log(1024));
      // eslint-disable-next-line no-restricted-properties
      return `${Math.round((size / Math.pow(1024, i)) * 100) / 100} ${units[i]}`;
    },
    formatDate(dateTimeString: string): string {
      const date = new Date(dateTimeString);
      const formattedDate = date.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      return formattedDate;
    },
    async getBreadcrumb() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/breadcrumb/${this.planOdId}/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        this.breadcrumb = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    showConfirmationModal(video: any) {
      this.selectedVideoToReplace = video;
      this.showConfirmation = true;
    },
    closeConfirmationModal() {
      this.selectedVideoToReplace = null;
      this.showConfirmation = false;
    },
    async getGalleryReplace(planId: number, name: string, folderId: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;

        const responseFolders = await axios.get(`${apiUrl}/galleries/${planId}?`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        const responseVideos = await axios.get(`${apiUrl}/galleries/videos/${planId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });

        const folders = responseFolders.data.galleries.map((gallery: any) => ({
          id: gallery.id,
          name: gallery.name,
          type: 'folder',
          expanded: false,
          videos: responseVideos.data.filter((video: any) => video.parentId === gallery.id),
        }));

        // eslint-disable-next-line max-len
        const videosNotInFolders = responseVideos.data.filter(
          (video: any) => video.parentId === null,
        );

        this.availableItems = [
          ...folders,
          ...videosNotInFolders.map((video: any) => ({
            id: video.id,
            name: video.name,
            type: 'video',
          })),
        ];
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async replaceVideo(video: any) {
      this.selectedVideoToReplace = video;
      this.showReplaceVideoDialog = true;
      await this.getGalleryReplace(this.planOdId, '', this.$route.params.id);
    },
    async replaceSelectedVideo(newVideo: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL as string;
        await axios.post(
          `${apiUrl}/replace-file`,
          {
            customer_plans_id: this.planOdId,
            new_video_hash: newVideo.hash,
            old_video_hash: this.selected[0].hash,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        const description = `Vídeo ${this.selected[0].name} do hash ${this.selected[0].hash} substituído pelo novo vídeo ${newVideo.name} do hash ${newVideo.hash}.`;
        await this.logUserAction('Modification', 'Success', description);

        this.showToast('Video successfully replaced', 'success');
        await this.$router.push({ name: 'Galleries' });
      } catch (error) {
        const description = `Erro ao substituir o vídeo ${this.selected[0].name} do hash ${this.selected[0].hash} pelo novo vídeo ${newVideo.name} do hash ${newVideo.hash}.`;
        await this.logUserAction('Modification', 'Error', description);

        this.showToast('Error replaced video', 'error');
        console.error('Error replaced video:', error);
      }
    },
    async moveVideo() {
      const targetFolder = this.folders.find((folder: any) => folder.id === this.moveToFolderId);
      const targetFolderName = targetFolder ? targetFolder.name : 'desconhecida';
      if (this.$refs.moveVideoForm && (this.$refs.moveVideoForm as any).validate) {
        try {
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.put(
            `${apiUrl}/moveVideo/${this.planOdId}/${this.selected[0].id}`,
            {
              id: this.selected[0].id,
              id_customer_plans: this.planOdId,
              parentId: this.moveToFolderId,
            },
            {
              headers: {
                Authorization: `Bearer ${this.userToken}`,
              },
            },
          );
          if (response.status === 200) {
            // eslint-disable-next-line max-len
            const index = this.folder.items.findIndex(
              (videoItem: any) => videoItem.id === this.selected[0].id,
            );
            if (index !== -1) {
              this.folder.items.splice(index, 1);
            }

            const description = `Vídeo ${this.selected[0].name} movido para a pasta ${targetFolderName}.`;
            await this.logUserAction('Modification', 'Success', description);

            this.showToast('video_moved_successfully', 'success');
            this.closeMoveVideoDialog();
          }
        } catch (error) {
          try {
            const apiUrl = process.env.VUE_APP_API_URL;
            const response = await axios.put(
              `${apiUrl}/moveVideo/${this.planOdId}/${this.selected[0].id}`,
              {
                id: this.selected[0].id,
                id_customer_plans: this.planOdId,
                parentId: this.moveToFolderId,
              },
              {
                headers: {
                  Authorization: `Bearer ${this.userToken}`,
                },
              },
            );
            if (response.status === 200) {
              // eslint-disable-next-line max-len
              const index = this.folder.items.findIndex(
                (videoItem: any) => videoItem.id === this.selected[0].id,
              );
              if (index !== -1) {
                this.folder.items.splice(index, 1);
              }

              // eslint-disable-next-line no-shadow
              const description = `Vídeo ${this.selected[0].name} movido para a pasta ${targetFolderName}.`;
              await this.logUserAction('Modification', 'Success', description);

              this.showToast('video_moved_successfully_on_retry', 'success');
              this.closeMoveVideoDialog();
            }
          } catch (retryError) {
            // eslint-disable-next-line no-shadow
            const description = `Erro ao mover o vídeo ${this.selected[0].name} para a pasta ${targetFolderName}`;
            await this.logUserAction('Modification', 'Error', description);

            this.showToast('Unable to perform this action, please try again later.', 'error');
          }
        }
      }
    },
    customSort(items: any[]) {
      return items;
    },
    handleSort(column: { key: string }) {
      // Se clicar na mesma coluna, inverte a ordem
      if (column.key === this.sortField) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        // Se clicar em uma coluna diferente, define ela como a coluna de ordenação
        this.sortField = column.key;
        this.sortOrder = 'asc'; // Começa com ordenação ascendente
      }

      console.log('Sorting by:', this.sortField, 'Order:', this.sortOrder);

      // Após mudar a ordenação, recarrega os vídeos com a nova ordenação
      this.getAllVideos();
    },
  },
});
